// extracted by mini-css-extract-plugin
export default {"homePageStack":"HomePage_homePageStack__OYN2x"};